import TypefaceSpecimen from '@/components/TypefaceTester'
import { createDataAttribute } from 'next-sanity'

interface TypeTesterBlockProps {
	heading?: string
	defaultPreviewText?: string
	initialFontSize?: number
	initialLeading?: number
	backgroundImage?: any
	backgroundColour?: {hex: string}
	textColour?: {hex: string}
	fonts: {
		name: string
		file: any
		weight: string|number
		style: 'normal'|'italic'
	}[]
	documentId: string
	_key: string
}

export default function TypeTesterBlock({ heading, defaultPreviewText, initialFontSize, initialLeading, backgroundImage, backgroundColour, textColour, fonts, documentId, _key }: TypeTesterBlockProps) {
	return (
		<div
			className="section col-span-full my-section--sm"
			key={_key}
			data-sanity={createDataAttribute({
				id: documentId,
				type: 'project',
				path: `contentBlocks[_key=="${_key}"]`,
			}).toString()}
		>
			<TypefaceSpecimen
				heading={heading || 'Type Tester'}
				defaultPreviewText={defaultPreviewText || "The quick brown fox jumps over the lazy dog"}
				fonts={fonts}
				initialFontSize={initialFontSize || 120}
				initialLeading={initialLeading || 0.95}
				bgImage={backgroundImage}
				bgColour={backgroundColour?.hex || '#eee'}
				textColour={textColour?.hex || '#000'}
			/>
		</div>
	)
}
